export default __webpack_public_path__ + "static/media/marvel.c067ec43.png";